<script>
export let msg_show;
export let msg_text;
export let msg_type; // error or success
export let msg_forever;


function hideCard() {
	if (!msg_forever) {
		msg_show = false;
	}
}

</script>


<style>

.msg-card {
	margin-bottom: 2rem !important;
	height: unset !important
}


.msg-card:hover {
	/*cursor: pointer;*/
}

.msg-card.error {
    background: #fdf6f5 !important;
    border-color: #d0a9a5 !important;
}

.msg-card.success {
	background: #e8ebf5 !important;
    border-color: #a9b6ec !important;
}

.card-content {
	padding: 0.75rem !important;
}

p {
	color: var(--text-dark);
}

:global(p a) {
	color: var(--text-dark) !important;
	text-decoration: underline;
}

</style>



<div class="card msg-card" class:is-hidden={!msg_show} on:click={hideCard} class:error={msg_type === 'error'} class:success={msg_type === 'success'}>

	<div class="card-content">

		<p class="has-text-centered">
			{#if msg_text}
			{@html msg_text}
			{:else}
			{#if msg_type === 'error'}
			Error!
			{:else if msg_type === 'success'}
			Success!
			{/if}
			{/if}
		</p>

	</div>

</div>

